module.exports = __webpack_public_path__ + "static/media/Start-Illustration.3f1fcd42.png";